/* 🤖 this file was generated by svg-to-ts */
export const sbIconsSort: {
  name: 'sort';
  data: string;
} = {
  name: 'sort',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.676 11.81 1.9-1.909a.834.834 0 1 1 1.18 1.18l-3.321 3.32a.83.83 0 0 1-.274.174.781.781 0 0 1-.631 0 .83.83 0 0 1-.274-.174l-3.321-3.32A.834.834 0 0 1 9.114 9.9l1.901 1.91V2.188a.83.83 0 1 1 1.66 0v9.623ZM3.324 4.185l-1.9 1.91a.834.834 0 0 1-1.18-1.18l3.321-3.32a.83.83 0 0 1 .274-.175.83.83 0 0 1 .631 0 .83.83 0 0 1 .274.175l3.321 3.32a.83.83 0 0 1-.27 1.361.83.83 0 0 1-.909-.181l-1.901-1.91v9.622a.83.83 0 1 1-1.66 0V4.185Z"/></svg>`
};
